export default __webpack_public_path__ + "static/media/web_design.881ece37.svg";